// Merchant uyum bandındaki metin. Eskiden SABİTTİ ("Lütfen evrak ve sözleşmelerinizi
// kontrol ediniz.") ve yanıltıyordu: kilit imza, kaşe veya banka bilgisinden de gelebiliyor.
// Merchant evraklara bakıp hepsini "Onaylandı" görüyor ve ne yapacağını anlamıyordu.
//
// breakdown: AuthContext'teki complianceBreakdown → { documents, agreements, signature, bank }
//   Alanlar BE'nin check-company-documents-complete yanıtından gelir. DİKKAT: BE imza,
//   kaşe ve imza yetkilisi adını TEK alanda (signatureComplete) topluyor; bu yüzden üçünü
//   ayrı ayrı yazamıyoruz, birlikte söylüyoruz.
// agreementApproved / documentsApproved: kilit yokken de "onay bekliyor" durumunu ayırt eder.

// "a", "a ve b", "a, b ve c"
function joinTurkish(items) {
  if (items.length <= 1) return items[0] || "";
  return `${items.slice(0, -1).join(", ")} ve ${items[items.length - 1]}`;
}

export function getMerchantComplianceMissing(breakdown) {
  if (!breakdown) return [];
  const missing = [];
  if (!breakdown.documents) missing.push("zorunlu evraklarınız");
  if (!breakdown.agreements) missing.push("iş birliği sözleşmeniz");
  if (!breakdown.signature) missing.push("imza yetkilisi, firma imzası ve kaşeniz");
  if (!breakdown.bank) missing.push("banka bilgileriniz");
  return missing;
}

export function getMerchantComplianceMessage(breakdown, options = {}) {
  const { agreementApproved = true, documentsApproved = true } = options;
  const missing = getMerchantComplianceMissing(breakdown);

  if (missing.length > 0) {
    return `${joinTurkish(missing)} eksik.`;
  }

  // Kilit yok ama band görünüyorsa: yüklenmiş fakat onay bekleyen kayıt vardır.
  if (!agreementApproved || !documentsApproved) {
    return "Evrak ve sözleşmelerinizde onay bekleyen kayıt var.";
  }

  // Kırılım okunamadıysa (breakdown null) eski davranışa düşülür.
  return "Lütfen evrak ve sözleşmelerinizi kontrol ediniz.";
}
